import Pdf from "assets/img/svg/pdf";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import type { ArticleSignedAgreement } from "store/articleStore";
import { downloadArticleAgreement, fetchArticleAgreements } from "store/articleStore";
import type { RootState } from "store/store";
import { useAppDispatch } from "store/store";

import EmptyState from "../EmptyState";

type TProps = {
    articleId: number;
    company?: { avatarUrl: string | null; name: string } | null;
};

const BPArticleAgreements = ({ articleId, company }: TProps) => {
    const [t] = useTranslation();
    const dispatch = useAppDispatch();

    const agreements = useSelector((state: RootState) => state.article.articleAgreements);

    useEffect(() => {
        if (articleId) {
            dispatch(fetchArticleAgreements(articleId));
        }
    }, [dispatch, articleId]);

    const handleDownload = (agreement: ArticleSignedAgreement) => {
        dispatch(downloadArticleAgreement({ articleId, agreement }));
    };

    return (
        <div className="flex flex-col gap-3">
            <h3 className="font-poppins text-base font-semibold">{t("ShowDetails.SignedContracts")}</h3>
            {agreements.length > 0 ? (
                agreements.map((agreement) => (
                    <div
                        className="flex items-center justify-between gap-3 rounded border border-slate-200 bg-white px-3 py-2"
                        key={agreement.id}
                    >
                        <button
                            className="flex items-center gap-2 text-left text-sm hover:underline"
                            onClick={() => handleDownload(agreement)}
                        >
                            <Pdf />
                            <span>{agreement.filename?.split(".")[0] ?? `Contrat_${agreement.id}`}</span>
                        </button>
                        {company && (
                            <span className="flex items-center gap-1.5 text-xs text-slate-500">
                                {company.avatarUrl && (
                                    <img className="h-5 w-5 rounded" src={company.avatarUrl} alt="avatar-company" />
                                )}
                                {company.name}
                            </span>
                        )}
                    </div>
                ))
            ) : (
                <EmptyState type="documents" sx={{ margin: "0 auto" }} />
            )}
        </div>
    );
};

export default BPArticleAgreements;
